import { ReactNode } from 'react';
import './BodyTabs.scss';
const BodyTabs = ({ children }: { children: ReactNode }) => {
  return <div id="bodyTabs">{children}</div>;
};

export default BodyTabs;
